<script setup lang="ts">
import { useTemplateRef } from 'vue'
import type { IBrxmProps } from '../../ts/interfaces/IBrxmProps'
import { useBrxmData } from '../../composables/useBrxmData'
import { CarouselDesktopSizes, ECarouselDesktopWidth } from '@/ui/plushComponents/VCarousel/types'
import { useVisibilityTracking } from '@/cms-ui/composables/useAnalytics'

const props = defineProps<IBrxmProps>()
const data = useBrxmData(props, 'PRODUCT_LIST')
const productListRef = useTemplateRef('productListRef')

useVisibilityTracking(productListRef, 'ProductList', 'ProductList')
</script>

<template>
    <section
        ref="productListRef"
        class="space-standard overflow-hidden"
        :data-test="data.id"
    >
        <div class="container">
            <VCarousel
                :class="[
                    data.mobileLayout.toLowerCase() === ECarouselDesktopWidth.GRID ? 'hidden' : 'block',
                    data.desktopLayout.toLowerCase() === ECarouselDesktopWidth.GRID ? 'lg:hidden' : 'lg:block',
                ]"
                :dark="data.darkmode"
                mobile-slides-variant="oneBigCard"
                tablet-slides-variant="twoCards"
                desktop-slides-per-view="3"
                :disable-mobile="data.mobileLayout.toLowerCase() === ECarouselDesktopWidth.GRID"
                :disable-tablet="data.mobileLayout.toLowerCase() === ECarouselDesktopWidth.GRID"
                :disable-desktop="data.desktopLayout.toLowerCase() === ECarouselDesktopWidth.GRID"
                :desktop-size="CarouselDesktopSizes.LARGE"
                desktop-width="grid"
                data-test="product-list-cards"
                carousel-aria-label="product-list-cards"
            >
                <template
                    v-for="(product, index) in data.products"
                    :key="`${product?.data?.productName?.replaceAll(' ', '_')}_${index}`"
                >
                    <ProductListPartsProductCard
                        v-if="product.data"
                        :product="product.data"
                        :default-installment="
                            data.defaultInstallmentForAllCarts || product.definition?.defaultInstallment
                        "
                        :badges="product.definition?.badges"
                        :installment-selector="data.installmentSelector"
                        :product-button="product.definition?.button"
                        :price-badge="data.priceBadge"
                        :page="page"
                        :mobile-layout="data.mobileLayout"
                        :desktop-layout="data.desktopLayout"
                    />
                </template>

                <template #bottom>
                    <VCarouselScrollbar />
                </template>
            </VCarousel>

            <div
                :class="[
                    data.mobileLayout.toLowerCase() !== ECarouselDesktopWidth.GRID ? 'hidden' : 'container-grid',
                    data.desktopLayout.toLowerCase() !== ECarouselDesktopWidth.GRID ? 'lg:hidden' : 'lg:container-grid',
                ]"
                class="container-grid"
            >
                <template
                    v-for="(product, index) in data.products"
                    :key="`${product?.data?.productName?.replaceAll(' ', '_')}_${index}`"
                >
                    <ProductListPartsProductCard
                        v-if="product.data"
                        :product="product.data"
                        :default-installment="
                            data.defaultInstallmentForAllCarts || product.definition?.defaultInstallment
                        "
                        :badges="product.definition?.badges"
                        :installment-selector="data.installmentSelector"
                        :product-button="product.definition?.button"
                        :price-badge="data.priceBadge"
                        :page="page"
                        :mobile-layout="data.mobileLayout"
                        :desktop-layout="data.desktopLayout"
                    />
                </template>
            </div>
        </div>
    </section>
</template>
